import { Cell, Text, VFlow } from 'bold-ui'
import { MedicamentoCatmatSelectField } from 'components/form/field/select/MedicamentoSelectField'
import React from 'react'
import { MetaRoot } from 'util/metaPath'

import { MedicamentoFormModel } from '../MedicamentoFormModel'

export interface MedicamentoSectionProps {
  path: MetaRoot<MedicamentoFormModel>
  values: MedicamentoFormModel
}

export default function MedicamentoSection({ path, values }: MedicamentoSectionProps) {
  return (
    <>
      <Cell size={6} data-testid='PrincipioAtivo'>
        <MedicamentoCatmatSelectField
          name={path.principioAtivoCombo}
          label='Princípio ativo / medicamento'
          required
          data-testid='PrincipioAtivoCombobox'
        />
      </Cell>
      <Cell size={6} data-testid='Concentracao'>
        <VFlow vSpacing={0.2}>
          <Text fontWeight='bold'>Concentração</Text>
          <Text data-testid='ConcentracaoLabel'>{values?.principioAtivoCombo?.medicamento?.concentracao ?? '-'} </Text>
        </VFlow>
      </Cell>
    </>
  )
}
